<script setup lang="ts">
import type { CartOrderSummary } from '@/types/checkout';

const props = defineProps({
	data: {
		type: Object as PropType<CartOrderSummary>,
		required: true,
	},
});

const currencyCode = computed(() => props.data.cartItems?.[0]?.currency?.code);
const isDiscounted = computed(() => {
	const discountedPrice = props.data.cartItems?.[0]?.totalDiscount;
	const originalPrice = props.data.cartItems?.[0]?.total;
	if (!discountedPrice) {
		return false;
	}
	return discountedPrice < originalPrice;
});
</script>
<template>
  <div class="order-summary">
    <h2 class="text-sm text-medium">
      Order Summary
    </h2>
    <div
      v-for="(cartItem, cartItemIndex) in data.cartItems"
      :key="cartItemIndex"
      class="ticket-detail"
    >
      <span class="text-sm text-regular">{{ `${cartItem.quantity}x ${cartItem.name}` }}</span>
      <div class="ticket-total">
        <p
          v-if="isDiscounted && cartItem.totalDiscount"
          class="text-sm text-regular --discount"
        >
          {{ formatCurrency(cartItem.totalDiscount, cartItem?.currency?.code) }}
        </p>
        <p
          :class="[
            'text-sm',
            'text-regular',
            {
              'line-through': isDiscounted
            }
          ]"
        >
          {{ formatCurrency(cartItem.total, cartItem?.currency?.code) }}
        </p>
      </div>
    </div>
    <div class="total">
      <span class="text-sm text-medium">Total</span>
      <span class="text-sm text-medium">{{
        formatCurrency(data.total, currencyCode)
      }}</span>
    </div>
  </div>
</template>
<style scoped lang="scss">
.order-summary {
    display: flex;
    flex-direction: column;
    gap: spacings-get(3);
    margin-bottom: spacings-get(8);

    .ticket-detail,
    .total {
      display: flex;
      justify-content: space-between;
      text-align: end;
    }
  }
</style>